import { Reservation } from '../../shared/types'
import { Dialog } from '../components/dialog'
import { Form } from '../reservations/form'

export function NewReservation({
	data,
	onClose,
}: {
	data: Partial<Reservation>
	onClose: VoidFunction
}) {
	return (
		<Dialog heading="Vytvořit rezervaci" isOpen onOpenChange={onClose}>
			<div className="p-4 overflow-auto">
				<Form data={data} onClose={onClose} />
			</div>
		</Dialog>
	)
}
